import { render } from "./PhysicalMeetingForm.vue?vue&type=template&id=00ed3fc5"
import script from "./PhysicalMeetingForm.vue?vue&type=script&lang=js"
export * from "./PhysicalMeetingForm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2367962886/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__